import Button from "../../../../../shared/components/Button";
import Spinner from "../../../../../shared/components/Spinner";
import { siteTexts } from "../../../../../shared/i18n/siteTexts";
import type { NotificationPreferences } from "../../../shared/services/notificationsService";
import ProfileAccordionSection from "../ProfileAccordionSection";
import UserProfileSectionHeader from "../UserProfileSectionHeader";

const NOTIFICATION_PREFERENCE_KEYS: Array<keyof NotificationPreferences> = [
  "inApp",
  "email",
  "events",
  "ranking",
  "payments",
  "achievements",
];

type ProfileNotificationPreferencesTabProps = {
  open: boolean;
  onToggle: () => void;
  preferences: NotificationPreferences;
  loading: boolean;
  saving: boolean;
  error: string;
  onPreferencesChange: (preferences: NotificationPreferences) => void;
  onSave: () => void;
};

export default function ProfileNotificationPreferencesTab({
  open,
  onToggle,
  preferences,
  loading,
  saving,
  error,
  onPreferencesChange,
  onSave,
}: ProfileNotificationPreferencesTabProps) {
  return (
    <ProfileAccordionSection
      id="profile-notifications"
      icon="notifications"
      title={siteTexts.profile.user.notificationPreferences.title}
      subtitle={siteTexts.profile.user.notificationPreferences.description}
      open={open}
      onToggle={onToggle}
    >
      <section className="user-profile-notification-preferences">
        <UserProfileSectionHeader
          icon="notifications"
          title={siteTexts.profile.user.notificationPreferences.title}
          description={siteTexts.profile.user.notificationPreferences.description}
        />

        {loading ? (
          <div className="user-profile-achievements-loading">
            <Spinner />
            <span>{siteTexts.profile.user.notificationPreferences.loading}</span>
          </div>
        ) : (
          <>
            <div className="user-profile-notification-grid">
              {NOTIFICATION_PREFERENCE_KEYS.map((key) => (
                <label className="user-profile-notification-toggle" key={key}>
                  <span>
                    {
                      siteTexts.profile.user.notificationPreferences.options[
                        key
                      ]
                    }
                  </span>
                  <input
                    type="checkbox"
                    checked={preferences[key]}
                    onChange={(event) =>
                      onPreferencesChange({
                        ...preferences,
                        [key]: event.target.checked,
                      })
                    }
                  />
                  <span aria-hidden="true" />
                </label>
              ))}
            </div>
            {error && <p className="status-message">{error}</p>}
            <div className="user-profile-actions">
              <Button
                type="button"
                variant="primary"
                onClick={onSave}
                disabled={saving}
              >
                {saving
                  ? siteTexts.profile.user.notificationPreferences.saving
                  : siteTexts.profile.user.notificationPreferences.save}
              </Button>
            </div>
          </>
        )}
      </section>
    </ProfileAccordionSection>
  );
}
